import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { useContext, useEffect, useState } from "react";
import { APIContext } from "../../Contexts/APIContext";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Line from "../../Utilities/Line";
import TableContainer from "@mui/material/TableContainer";
import ResponsiveTable from "../../Utilities/ResponsiveTable";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import OrgUserTable from "./OrgUserTable";
import { OrganisationViewModel } from "./ViewModels/OrganisationVieModel";
import SiteUsersDialog from "./SiteUsersDialog";
import Button from "@mui/material/Button";

export default function MyOrganisation() {
    const { get } = useContext(APIContext);
    const [organisation, setOrganisation] = useState<OrganisationViewModel | null>(null);
    const [openId, setOpenId] = useState<string | null>(null);

    useEffect(() => {
        getOrganisation();
    }, []);

    const getOrganisation = async () => {
        get('organisation', 'GetMyOrganisation', setOrganisation);
    }

    const handleClose = (refresh: boolean) => {
        if (refresh) {
            getOrganisation();
        }
        setOpenId(null)
    }

    return (
        organisation !== null ?
            <Grid container>
                <Grid size={12}>
                    <Typography variant="h4" gutterBottom>
                        My Organisation - {organisation.organisationName}
                    </Typography>
                </Grid>
                <Grid size={6} component={Paper}>
                    <Grid container>
                        <Grid size={12}>
                            <Typography variant="h6">Organisation Details</Typography>
                        </Grid>
                        <Line />
                        <Grid size={3}>
                            <Typography variant="h6">Member Number: </Typography>
                        </Grid>
                        <Grid size={3}>
                            <TextField value={organisation.memberNumber} />
                        </Grid>
                        <Grid size={3}>
                            <Typography variant="h6">Licence Type: </Typography>
                        </Grid>
                        <Grid size={3}>
                            <TextField value={organisation.licenseType} />
                        </Grid>
                        <Grid size={3}>
                            <Typography variant="h6">Location: </Typography>
                        </Grid>
                        <Grid size={3}>
                            <TextField value={organisation.location} />
                        </Grid>
                        <Grid size={3}>
                            <Typography variant="h6">Expiry Date: </Typography>
                        </Grid>
                        <Grid size={3}>
                            <TextField value={organisation.expiry} />
                        </Grid>
                        <Grid size={3}>
                            <Typography variant="h6">Number of Sites: </Typography>
                        </Grid>
                        <Grid size={3}>
                            <TextField value={organisation.sites.length} />
                        </Grid>
                        <Grid size={3}>
                            <Typography variant="h6">Active Members: </Typography>
                        </Grid>
                        <Grid size={3}>
                            <TextField value={organisation.totalMembers} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={6} component={Paper}>
                    <OrgUserTable users={organisation.managers} title="Manager Details" refresh={getOrganisation} orgId={organisation.id} role="Manager" />
                </Grid>
                <Grid size={12} component={Paper}>
                    <Grid container>
                        <Grid size={12}>
                            <Typography variant="h6">Sites</Typography>
                        </Grid>
                        <Line />
                        <TableContainer sx={{ width: "100%" }}>
                            <ResponsiveTable>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Town</TableCell>
                                        <TableCell>Region</TableCell>
                                        <TableCell>Country</TableCell>
                                        <TableCell>Postcode</TableCell>
                                        <TableCell>Number of Members</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ width: "100%" }}>
                                    {organisation.sites !== null &&
                                        organisation.sites.map((row) =>
                                            <TableRow key={row.siteNumber} >
                                                <TableCell>{row.officeName}</TableCell>
                                                <TableCell>{row.town}</TableCell>
                                                <TableCell>{row.region}</TableCell>
                                                <TableCell>{row.country}</TableCell>
                                                <TableCell>{row.postcode}</TableCell>
                                                <TableCell>{row.members.length}</TableCell>
                                                <TableCell align={'right'}><Button fullWidth={false} variant={'contained'} size={'small'} onClick={() => { setOpenId(row.id) }}>Edit Members</Button></TableCell>
                                            </TableRow>)
                                    }
                                </TableBody>
                            </ResponsiveTable>
                        </TableContainer>
                    </Grid>
                </Grid>
                {openId !== null &&
                    <SiteUsersDialog open={openId !== null} onClose={handleClose} siteId={openId} orgId={organisation.id} />
                }
            </Grid>
            :
            <Grid container justifyContent="center">
                <Grid>
                    <CircularProgress />
                </Grid>
            </Grid>

    );
}
